import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'

import { i18nKeys } from '../app.i18n'
import { links } from '../app.links'
import { ACTIVE_CLASS_NAME, NAVLINK_CLASS_NAME } from '../shared'

type Props = RouteComponentProps<{}> & {
  t: TranslationFunction
}

export const FunctionalNav: SFC<Props> = ({ match, t }) => (
  <>
    <div className="sidebar__title">{t(i18nKeys.frontFace.activityBar.functional)}</div>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      activeClassName={ACTIVE_CLASS_NAME}
      to={links.frontFace.functional.team(match.path)}
    >
      {t(i18nKeys.frontFace.functional.team)}
    </NavLink>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      activeClassName={ACTIVE_CLASS_NAME}
      to={links.frontFace.functional.reviews(match.path)}
    >
      {t(i18nKeys.frontFace.functional.reviews)}
    </NavLink>
  </>
)



// WEBPACK FOOTER //
// ./src/app/sidebar-navigation/functional.tsx